import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useParameterTypeValueReducer = () => useSelector((state: ApplicationState) => state.parameterTypeValue);
